import type { RouteRecordRaw } from "vue-router";
import SizingsMain from "@/views/sizings/SizingsMain.vue";
import SizingsList from "@/views/sizings/SizingsList.vue";
import Reports from "@/views/sizings/SizingsReports.vue";
import scenariosRoutes, { propify } from "./scenarios";

const sizingsRoutes: Array<RouteRecordRaw> = [
  {
    path: "/sizings/:sizingId",
    name: "Sizing",
    component: SizingsMain,
    props: propify,
    children: [
      ...scenariosRoutes,
      {
        path: "/sizings/:sizingId/reports",
        name: "Reports",
        component: Reports,
        props: route => ({ sizingId: route.params.sizingId }),
        meta: {
          title: "Sizing Reports",
          requiresAuth: true
        }
      }
    ]
  },
  {
    path: "/sizings",
    name: "Sizings",
    component: SizingsList,
    meta: {
      title: "Sizings",
      requiresAuth: true
    }
  }
];

export default sizingsRoutes;
